module.exports = __webpack_public_path__ + "static/media/icono_locucion.87e80fe9.svg";